var $6a04950c21e50ddd$exports = {};
$6a04950c21e50ddd$exports = {
    "loading": `Bet\xf6lt\xe9s folyamatban\u{2026}`,
    "loadingMore": `Tov\xe1bbiak bet\xf6lt\xe9se folyamatban\u{2026}`
};


export {$6a04950c21e50ddd$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
